<template>
    <div class="article-box">
        <div class="pics box white-bg">
            <ul class="id-tab">
                <li class="tab-current">模板商城</li>
            </ul>
            <div class="plr20">
                <section>
                    <div class="pics-list-price">
                        <ul>
                            <li>
                                <router-link to="/project/19">
                                    <i><img src="../../assets/images/pic06.jpg"></i>
                                    <h2>商品名称：索尼数码相机DSC-T2</h2>
                                    <p>镜头。卡尔·蔡司镜头 (Vario-Tessar)，镜头结构：9组11片（包括3片非球面镜，1片棱镜）。光学变焦：3倍</p>
                                    <span class="price-area"><em>￥</em>100.00</span><span class="pics-btn">立即购买</span>

                                </router-link>
                            </li>
                        </ul>
                    </div>
                </section>
                <section>
                    <div class="pics-list-price">
                        <ul>
                            <li>
                                <router-link to="/project/19">
                                    <i><img src="../../assets/images/pic06.jpg"></i>
                                    <h2>商品名称：索尼数码相机DSC-T2</h2>
                                    <p>镜头。卡尔·蔡司镜头 (Vario-Tessar)，镜头结构：9组11片（包括3片非球面镜，1片棱镜）。光学变焦：3倍</p>
                                    <span class="price-area"><em>￥</em>100.00</span><span class="pics-btn">立即购买</span>

                                </router-link>
                            </li>
                        </ul>
                    </div>
                </section>
            </div>
            <div class="pagelist"></div>
        </div>
        <!-- pics end-->
        <div class="clear blank"></div>
    </div>
</template>

<script>
    export default {
        name: "Index"
    }
</script>

<style scoped>

</style>